import graphql__5068a52d3ee791f30494 from "./__generated__/InformativeMapRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import InformativeMap from "../Maps/InformativeMap";

const InformativeMapRoute = props => {
  const { informativeMapSlug } = useParams();

  return (
    <AppQueryRenderer
      key={informativeMapSlug}
      query={InformativeMapRouteQuery}
      variables={{ informativeMapSlug }}
      component={InformativeMap}
      additionalProps={props}
    />
  );
};

const InformativeMapRouteQuery = graphql__5068a52d3ee791f30494;

export default InformativeMapRoute;
